export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  AUD: '$',
  CAD: '$',
  HKD: '$',
  CHF: 'CHF',
  ALL: 'Lek',
  AMD: 'AMD',
  AOA: 'AOA',
  ARS: '$',
  AZN: '₼',
  BAM: 'KM',
  BGN: 'лв',
  BOB: '$b',
  BRL: 'R$',
  BTC: 'BTC',
  BYM: 'Br',
  BZD: 'BZ$',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CZK: 'Kč',
  DOP: 'RD$',
  EGP: '£',
  GHS: '¢',
  IDR: 'Rp',
  INR: '₹',
  IRR: '﷼',
  KGS: 'лв',
  KRW: '₩',
  KZT: '₸',
  LKR: '₨',
  LTC: 'LTC',
  mBTC: 'mBTC',
  MNT: '₮',
  MXN: '$',
  MYR: 'RM',
  NGN: '₦',
  NOK: 'kr',
  NZD: '$',
  PBR: 'PBR',
  PEN: 'S/.',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PT1: 'PT1',
  PTH: 'PTH',
  PTU: 'PTU',
  PYG: 'Gs',
  RMB: 'RMB',
  RSD: 'Дин.',
  RUB: '₽',
  SEK: 'kr',
  SGD: '$',
  tEUR: 'tEUR',
  THB: '฿',
  TJS: 'TJS',
  TMT: 'TMT',
  TRY: '₺',
  TWD: 'NT$',
  TZS: 'TZS',
  UAH: '₴',
  UGX: 'UGX',
  UYU: '$U',
  VEF: 'Bs',
  VND: '₫',
  XAF: 'XAF',
  XOF: 'XOF',
  ZAR: 'R',
} as const;
